<script>
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  Option,
  OptionGroup,
  CheckboxGroup,
  Checkbox,
  Cascader,
  RadioGroup,
  Radio,
  DatePicker,
  TimePicker,
  Upload,
  Button,
  InputNumber,
  Autocomplete,
  Switch,
  Tooltip
} from 'element-ui';
import { getButtonType, initModel } from '@/util/componentUtil';
import {addClass, copyProperty, getShowList} from '@/util/componentCoreUtil';
import elementResizeDetector from 'element-resize-detector';
import { debounce } from '@/util/util';
import {
  FIELD_TYPE_CASCADER,
  FIELD_TYPE_CHECKBOX,
  FIELD_TYPE_CHECKBOX_GROUP,
  FIELD_TYPE_DATE,
  FIELD_TYPE_DATERANGE,
  FIELD_TYPE_DATETIME,
  FIELD_TYPE_DATETIME_RANGE,
  FIELD_TYPE_FILE,
  FIELD_TYPE_INPUT,
  FIELD_TYPE_INPUT_NUMBER,
  FIELD_TYPE_LIST_POP_MULTI,
  FIELD_TYPE_LIST_POP_ONE,
  FIELD_TYPE_MONTH,
  FIELD_TYPE_MULTIPLE_SELECT,
  FIELD_TYPE_NATIVE_INPUT_NUMBER,
  FIELD_TYPE_POP_MULTI,
  FIELD_TYPE_POP_ONE,
  FIELD_TYPE_RADIO_GROUP,
  FIELD_TYPE_RICH_TEXT,
  FIELD_TYPE_SELECT,
  FIELD_TYPE_TEXTAREA,
  FIELD_TYPE_TIME,
  FIELD_TYPE_TIME_RANGE,
  FIELD_TYPE_TREE_POP_MULTI,
  FIELD_TYPE_TREE_POP_ONE,
  FIELD_TYPE_YEAR,
  FIELD_TYPE_EMPTY, FIELD_TYPE_TITLE, FIELD_TYPE_SWITCH
} from '@/util/x-condition-constant';
import * as appUtils from '@/util/appUtils';
import { isEnter } from '@/util/keyCode';
import { MULTIPLE_SELECT, SINGLE_SELECT } from '@/mixin/search-dialog-mixin';
import Vue from 'vue';
import XTinymce from '../x-tinymce/x-tinymce.vue';

/**
 * 获取item的span
 * @param model
 * @param config
 * @param item
 * @returns {*}
 */
const getSpan = ({model, config, item}) => {
  return item.spanMethod ? item.spanMethod({model, config, item}) : item.span;
};
export default {
  name: 'XCondition',
  components: {
    [Form.name]: Form,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Cascader.name]: Cascader,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [DatePicker.name]: DatePicker,
    [TimePicker.name]: TimePicker,
    [Row.name]: Row,
    [Col.name]: Col,
    [Upload.name]: Upload,
    [Button.name]: Button
  },
  props: {
    conditionConfig: {
      type: Object,
      default() {
        return {
          /* model: {}, // form的model属性, 如果是checkbox-group对应的field,最好声明为一个空数组，如果np-search-list，就声明为null
            rules: {}, // 整个表单校验规则
            labelWidth: '100px', // 左边文字统一宽度,
            disabled: false,
            list: [
              {
                formItemClass: {}, // form-item样式
                readonly: false, // 是否只读, radio, select cascader等组件没有readonly属性，这些组件的readonly会传入disabled中
                disabled: false, // 是否不可使用
                field: '', // 字段，与queryParams中的属性对应, form也是对应这个属性
                fieldCode: '', // 字段，主要用于配置化查询，譬如开始时间和结束时间，都是同一个fieldCode，但是不同的field
                label: '', // 左边的文字
                labelMethod: ({model, config, item}) => {return '';}, // 动态获取label的方法
                placeholder: '', // 提示文字
                type: 'input', // 类型，input,select,multipleSelect,cascader,radio,date,datetime,daterange,time,timerange,slot
                inputType: 'text', // 输入框的类型text textarea
                value: '', // 用于初始化model的值
                optionList: [], // select的选项 或者 使用el-checkboxgroup时的checkbox选项列表, radio-group[{text: '男',label: 'man'},{text: '女',label: 'women'}]
                text: '', // checkbox显示的文字，避免和el-form-item的label冲突
                props： {label, value, key} // 渲染el-option对应的字段
                enter: () => {},
                change: ({item, value}) => {},
                errorSlot: {
                  name: '' // 错误插槽的名称
                },
                editable, // el-date-picker的输入框是否可以编辑
                toQuery: false, // 是否用于查询，除了false以外，undefined或者其它值都当作是true
                span: 6, // 跨度，每行分成24等份，span表示占其中的多少份
                spanMethod: ({model, config, item}) => {return 6;} // 动态获取span的方法
              }
            ] */
        };
      }
    },
    drawerConfig: {
      type: Object,
      default() {
        return {
          /**
           * 是否使用展开/收起的功能，如果是true,就表示使用，false表示不使用
           */
          show: false,
          openText: '展开',
          closeText: '收起',
          limit: 4
        };
      }
    },
    // drawer状态，true表示展开，false表示收起
    drawerFlag: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      realDrawerFlag: true
    };
  },
  render(createElement) {
    const hasOwnProperty = Object.prototype.hasOwnProperty;
    const children = [];
    // 最终显示的查询条件，用户通过点击展开和收起按钮来控制finalShowList的数量
    // 由于使用v-expand只能做到dom操作，无法做到根据条件的数量自动判断是否显示展开和收起按钮，另外对于多选框，当选中item的数量较多时，
    // 高度和相邻的条件会不一致，因此直接操作dom会相对麻烦
    let finalShowList = [];
    if (!this.realDrawerConfig.show || this.realDrawerFlag) {
      finalShowList = this.realShowList;
    } else {
      // 当realConditionList的数量小于5时，直接显示
      if (this.realShowList.length <= this.realDrawerConfig.limit) {
        finalShowList = this.realShowList;
      } else {
        finalShowList = this.realShowList.slice(0, this.realDrawerConfig.limit);
      }
    }
    // 转成二维数组
    const arr = [];
    let i = 0;
    let totalSpan = 0;
    const model = this.conditionConfig.model;
    for (const item of this.realShowList) {
      // 如果设置了动态获取span的方法，就通过方法来获取，否则就取item上的span属性
      const span = getSpan({model, conditionConfig: this.conditionConfig, item});
      if (item.newRow) {
        // 另起一行
        i += 1;
        totalSpan = span;
      } else {
        // let $totalSpan = totalSpan;
        // if (finalShowList.includes(item)) {
        //   $totalSpan = totalSpan + item.span;
        // }
        const $totalSpan = totalSpan + span;
        if ($totalSpan > 24) {
          // 另起一行
          i += 1;
          totalSpan = span;
        } else {
          totalSpan = $totalSpan;
        }
      }
      let subArr = arr[i];
      if (!subArr) {
        arr[i] = subArr = [];
      }
      subArr.push(item);
    }
    for (let i = 0; i < arr.length; i++) {
      const row = arr[i];
      const colList = [];
      let displayFlag = true;
      for (const item of row) {
        const field = item.field;
        // 判断item是否在显示列表，如果都不在，el-row就要加上display-none
        const style = {};
        if (finalShowList.includes(item)) {
          displayFlag = false;
        } else {
          style.display = 'none';
        }
        let formItemContent = [];
        const type = item.type;
        if (item.slot) {
          const fn = this.$scopedSlots[item.slot.name];
          if (fn) {
            const vNode = fn({
              item: item,
              model,
              conditionConfig: this.conditionConfig
            });
            if (Array.isArray(vNode)) {
              formItemContent = vNode;
            } else {
              formItemContent.push(vNode);
            }
          }
        } else if (item.render) {
          const vNode = item.render(createElement, {
            item: item,
            model,
            conditionConfig: this.conditionConfig
          });
          if (Array.isArray(vNode)) {
            formItemContent = vNode;
          } else {
            formItemContent.push(vNode);
          }
        } else if (type === FIELD_TYPE_EMPTY) {
          formItemContent.push(createElement('div'));
        } else if (type === FIELD_TYPE_TITLE) {
          formItemContent.push(createElement('div'));
        } else if (
          type === FIELD_TYPE_INPUT ||
          type === FIELD_TYPE_TEXTAREA ||
          type === FIELD_TYPE_NATIVE_INPUT_NUMBER
        ) {
          const buttonList = this.getVisibleInputButtonList(item);
          const adjustFlag = buttonList.length > 0;
          const contentSlots = [];
          if (item.suffixSlot && this.$scopedSlots[item.suffixSlot.name]) {
            contentSlots.push(
              createElement(
                'template',
                { slot: 'suffix' },
                this.$scopedSlots[item.suffixSlot.name]({ item })
              )
            );
          }
          let vNode;
          if (item.fetchSuggestions) {
            vNode = createElement(
              Autocomplete,
              this.getInputAttribute(item, adjustFlag),
              contentSlots
            );
          } else {
            const vSubNode = createElement(
              Input,
              this.getInputAttribute(item, adjustFlag),
              contentSlots
            );
            if (item.showTooltip) {
              let tooltipContent = item.tooltipContent;
              if (item.tooltipContentMethod) {
                tooltipContent = item.tooltipContentMethod({item, model, conditionConfig: this.conditionConfig, value: model[item.field]});
              }
              vNode = createElement(Tooltip, {
                props: {
                  // tooltip的内容为空也不显示
                  // value: isNotEmpty(tooltipContent),
                  content: tooltipContent,
                  placement: item.placement || 'top',
                }
              }, [vSubNode]);
            } else {
              vNode = vSubNode;
            }
          }
          if (adjustFlag) {
            const contentChildren = [vNode];
            const buttonChildren = [];
            for (const button of buttonList) {
              buttonChildren.push(
                createElement(
                  'el-button',
                  {
                    props: {
                      type: getButtonType({ item: button }),
                      disabled: this.isButtonDisabled(button, item)
                    },
                    key: button.field,
                    on: {
                      click: $event => {
                        this.handleInputButtonClick($event, item, button);
                      }
                    }
                  },
                  button.name
                )
              );
            }
            contentChildren.push(
              createElement(
                'div',
                {
                  class: 'x-condition-input-button-wrapper'
                },
                buttonChildren
              )
            );
            formItemContent.push(
              createElement(
                'div',
                {
                  class: { 'x-condition-adjust-input-form-item': adjustFlag }
                },
                contentChildren
              )
            );
          } else {
            formItemContent.push(vNode);
          }
        } else if (type === FIELD_TYPE_INPUT_NUMBER) {
          formItemContent.push(
            createElement(InputNumber, {
              props: {
                ...item,
                value: model[field],
                placeholder: this.getPlaceholder({item, defaultPlaceholder: '请输入'}),
                disabled: this.isDisabled(item)
              },
              on: {
                input: $event => {
                  model[field] = $event;
                },
                focus: $event => {
                  this.handleFocusChange(item, $event);
                },
                blur: $event => {
                  this.handleCommonBlur(item, $event);
                },
                change: ($event, oldValue) => {
                  this.handleCommonChange(item, $event, oldValue);
                }
              }
            })
          );
        } else if (type === FIELD_TYPE_SELECT || type === FIELD_TYPE_MULTIPLE_SELECT) {
          const popperAppendToBody = hasOwnProperty.call(item, 'popperAppendToBody')
            ? item.popperAppendToBody
            : true;
          const props = {
            type: item.type,
            filterable: item.filterable,
            allowCreate: item.allowCreate,
            disabled: this.isReadonlyDisabled(item),
            clearable: item.clearable || false,
            multiple: item.type === FIELD_TYPE_MULTIPLE_SELECT,
            defaultFirstOption: item.defaultFirstOption,
            placeholder: this.getPlaceholder({item, defaultPlaceholder: '请选择'}),
            value: model[field],
            popperAppendToBody
          };
          if (item.valueKey) {
            props.valueKey = item.valueKey;
          }
          formItemContent.push(
            createElement(
              Select,
              {
                class: 'x-condition-adjust-item',
                props,
                on: {
                  change: $event => {
                    this.handleCommonChange(item, $event);
                  },
                  input: $event => {
                    model[field] = $event;
                  },
                  'remove-tag': $event => {
                    item.removeTag &&
                      item.removeTag({
                        item,
                        model,
                        list: this.conditionConfig.list,
                        value: $event
                      });
                  }
                },
                nativeOn: {
                  keyup: $event => {
                    if (!isEnter($event)) {
                      return;
                    }
                    this.handleKeyupEnterNative(item, $event);
                  }
                }
              },
              this.createOptions({ item, options: item.options, createElement })
            )
          );
        } else if (type === FIELD_TYPE_CASCADER) {
          console.log('start render');
          if (!item.$hide) {
            console.log('real start render');
            formItemContent.push(
              createElement('el-cascader', {
                props: {
                  popperClass: 'x-condition-cascader',
                  disabled: this.isReadonlyDisabled(item),
                  clearable: item.clearable || false,
                  filterable: item.filterable || false,
                  placeholder: this.getPlaceholder({item, defaultPlaceholder: '请选择'}),
                  value: model[field],
                  props: item.props,
                  options: item.options
                },
                ref: item.ref,
                refInFor: true,
                on: {
                  change: $event => {
                    model[field] = $event;
                    this.handleCommonChange(item, $event);
                  }
                }
              })
            );
          }
        } else if (type === FIELD_TYPE_CHECKBOX) {
          formItemContent.push(
            createElement(
              'el-checkbox',
              {
                props: {
                  trueLabel: item.trueLabel,
                  falseLabel: item.falseLabel,
                  disabled: this.isReadonlyDisabled(item),
                  value: model[field]
                },
                on: {
                  input: $event => {
                    model[field] = $event;
                  },
                  change: $event => {
                    this.handleCommonChange(item, $event);
                  }
                }
              },
              item.text
            )
          );
        } else if (type === FIELD_TYPE_CHECKBOX_GROUP) {
          const checkboxs = [];
          if (Array.isArray(item.options)) {
            for (const option of item.options) {
              checkboxs.push(
                createElement(
                  'el-checkbox',
                  {
                    props: {
                      disabled: this.isReadonlyDisabled(option),
                      label: option.label
                    },
                    key: option.label
                  },
                  option.text
                )
              );
            }
          }
          formItemContent.push(
            createElement(
              'el-checkbox-group',
              {
                props: {
                  disabled: this.isReadonlyDisabled(item),
                  value: model[field]
                },
                on: {
                  input: $event => {
                    model[field] = $event;
                  },
                  change: $event => {
                    this.handleCommonChange(item, $event);
                  }
                }
              },
              checkboxs
            )
          );
        } else if (type === FIELD_TYPE_RADIO_GROUP) {
          const radios = [];
          if (Array.isArray(item.options)) {
            for (const option of item.options) {
              radios.push(
                createElement(
                  'el-radio',
                  {
                    props: {
                      disabled: this.isReadonlyDisabled(option),
                      label: option.label
                    },
                    key: option.label
                  },
                  option.text
                )
              );
            }
          }
          formItemContent.push(
            createElement(
              'el-radio-group',
              {
                props: {
                  value: model[field],
                  disabled: this.isDisabled(item)
                },
                on: {
                  change: $event => {
                    this.handleCommonChange(item, $event);
                  },
                  input: $event => {
                    model[field] = $event;
                  }
                }
              },
              radios
            )
          );
        } else if (type === FIELD_TYPE_SWITCH) {
          const props = {
            value: model[field],
            disabled: this.isReadonlyDisabled(item)
          };
          if (item.activeText) {
            props.activeText = item.activeText;
          }
          if (item.inactiveText) {
            props.inactiveText = item.inactiveText;
          }
          if (item.activeValue) {
            props.activeValue = item.activeValue;
          }
          if (item.inactiveValue) {
            props.inactiveValue = item.inactiveValue;
          }
          if (item.activeColor) {
            props.activeColor = item.activeColor;
          }
          if (item.inactiveColor) {
            props.inactiveColor = item.inactiveColor;
          }
          formItemContent.push(
              createElement(
                  Switch,
                  {
                    props,
                    on: {
                      input: $event => {
                        model[field] = $event;
                      }
                    }
                  }
              )
          );
        } else if (
          type === FIELD_TYPE_DATE ||
          type === FIELD_TYPE_YEAR ||
          type === FIELD_TYPE_MONTH ||
          type === FIELD_TYPE_DATETIME ||
          type === FIELD_TYPE_DATERANGE ||
          type === FIELD_TYPE_DATETIME_RANGE
        ) {
          const props = {
            format: item.format,
            pickerOptions: item.pickerOptions,
            valueFormat: item.valueFormat,
            readonly: this.isReadonly(item),
            editable: this.isEditable(item),
            type: item.type,
            disabled: this.isDisabled(item),
            clearable: item.clearable || false,
            defaultTime: item.defaultTime,
            value: model[field]
          };
          if (type === FIELD_TYPE_DATE) {
            props.placeholder = this.getPlaceholder({item, defaultPlaceholder: '请选择日期'});
          }
          if (type === FIELD_TYPE_YEAR) {
            props.placeholder = this.getPlaceholder({item, defaultPlaceholder: '请选择年份'});
          }
          if (type === FIELD_TYPE_MONTH) {
            props.placeholder = this.getPlaceholder({item, defaultPlaceholder: '请选择月份'});
          }
          if (type === FIELD_TYPE_DATETIME) {
            props.placeholder = this.getPlaceholder({item, defaultPlaceholder: '请选择日期时间'});
          }
          if (type === FIELD_TYPE_DATERANGE) {
            props.startPlaceholder = this.getPlaceholder({item, key: 'startPlaceholder', defaultPlaceholder: '请选择开始日期'});
            props.endPlaceholder = this.getPlaceholder({item, key: 'endPlaceholder', defaultPlaceholder: '请选择结束日期'});
          }
          if (type === FIELD_TYPE_DATETIME_RANGE) {
            props.startPlaceholder = this.getPlaceholder({item, key: 'startPlaceholder', defaultPlaceholder: '请选择开始日期时间'});
            props.endPlaceholder = this.getPlaceholder({item, key: 'endPlaceholder', defaultPlaceholder: '请选择结束日期时间'});
          }
          if (item.rangeSeparator && (type === FIELD_TYPE_DATERANGE || type === FIELD_TYPE_DATETIME_RANGE)) {
            props.rangeSeparator = item.rangeSeparator;
          }
          formItemContent.push(
            createElement('el-date-picker', {
              class: 'x-condition-adjust-item',
              props,
              on: {
                input: $event => {
                  model[field] = $event;
                },
                change: $event => {
                  this.handleCommonChange(item, $event);
                }
              }
            })
          );
        } else if (type === FIELD_TYPE_TIME || type === FIELD_TYPE_TIME_RANGE) {
          const props = {
            pickerOptions: item.pickerOptions,
            valueFormat: item.valueFormat,
            readonly: this.isReadonly(item),
            editable: this.isEditable(item),
            type: item.type,
            disabled: this.isDisabled(item),
            clearable: item.clearable || false,
            value: model[field],
            isRange: type === FIELD_TYPE_TIME_RANGE
          };
          if (type === FIELD_TYPE_TIME) {
            props.placeholder = this.getPlaceholder({item, defaultPlaceholder: '请选择时间'});
          }
          if (type === FIELD_TYPE_TIME_RANGE) {
            props.startPlaceholder = this.getPlaceholder({item, key: 'startPlaceholder', defaultPlaceholder: '请选择开始时间'});
            props.endPlaceholder = this.getPlaceholder({item, key: 'endPlaceholder', defaultPlaceholder: '请选择结束时间'});
          }
          formItemContent.push(
            createElement('el-time-picker', {
              class: 'x-condition-adjust-item',
              props,
              on: {
                input: $event => {
                  model[field] = $event;
                },
                change: $event => {
                  this.handleCommonChange(item, $event);
                }
              }
            })
          );
        } else if (type === FIELD_TYPE_POP_ONE || type === FIELD_TYPE_POP_MULTI) {
          const props = {
            value: model[field],
            dataCode: item.dataCode,
            presetButtonConfig: item.buttonConfig,
            disabled: this.isDisabled(item),
            appendResult: item.appendResult,
            searchOptionType: FIELD_TYPE_POP_ONE === item.type ? SINGLE_SELECT : MULTIPLE_SELECT,
            mode: item.mode,
            columns: item.columns,
            fullData: item.fullData,
            multipleMetaQuery: item.multipleMetaQuery,
            validate: item.validate
          };
          if (item.triggerSearch) {
            props.triggerSearch = async args => {
              await this.handleTriggerSearch(item, args);
            };
          }
          if (item.limit) {
            props.limit = item.limit;
          }
          copyProperty({source: item, target: props, key: 'dialogSelectType'});
          copyProperty({source: item, target: props, key: 'returnDataFn'});
          const attrs = {
            readonly: item.readonly || false,
            rowKey: item.rowKey,
            rowName: item.rowName,
            hasInput: item.hasInput,
            appendToBody: item.appendToBody,
            pageConfig: item.pageConfig,
            clearable: item.clearable,
            presetConfig: item.presetConfig,
            readonlyClearable: item.readonlyClearable,
            placeholder: this.getPlaceholder({item}),
            queryConfig: item.queryConfig,
            tabConfig: item.tabConfig,
            switchCondition: item.switchCondition,
            independentModel: item.independentModel,
            queryCode: item.queryCode
          };
          if (item.width) {
            attrs.width = item.width;
          }
          if (item.height) {
            attrs.height = item.height;
          }
          if (item.renderKey) {
            attrs.renderKey = item.renderKey;
          }
          formItemContent.push(
            createElement('x-meta-search-list', {
              props,
              attrs,
              on: {
                'remove-tag': ({ tag, index }) => {
                  item.removeTag &&
                    item.removeTag({ item, tag, model, list: this.conditionConfig.list, index });
                },
                'click-icon': $event => {
                  this.handleClickIcon(item, $event);
                },
                select: data => {
                  this.handleSearchListSelect(item, data);
                },
                clear: () => {
                  this.handleClear(item);
                },
                input: $event => {
                  model[field] = $event;
                },
                'update:fullData': data => {
                  this.handleSearchListUpdateFullData({ item, data });
                }
              }
            })
          );
        } else if (type === FIELD_TYPE_TREE_POP_ONE || type === FIELD_TYPE_TREE_POP_MULTI) {
          const props = {
            value: model[field],
            presetButtonConfig: item.buttonConfig,
            disabled: this.isDisabled(item),
            appendResult: item.appendResult,
            searchOptionType:
              FIELD_TYPE_TREE_POP_ONE === item.type ? SINGLE_SELECT : MULTIPLE_SELECT,
            mode: item.mode
          };
          if (item.triggerSearch) {
            props.triggerSearch = args => {
              this.handleTriggerSearch(item, args);
            };
          }
          if (item.limit) {
            props.limit = item.limit;
          }
          const attrs = {
            rowKey: item.rowKey,
            rowName: item.rowName,
            appendToBody: item.appendToBody,
            presetConfig: item.presetConfig,
            pageConfig: item.pageConfig,
            data: item.data,
            placeholder: this.getPlaceholder({item})
          };
          if (item.props) {
            attrs.props = item.props;
          }
          if (item.width) {
            attrs.width = item.width;
          }
          if (item.height) {
            attrs.height = item.height;
          }
          if (item.renderKey) {
            attrs.renderKey = item.renderKey;
          }
          formItemContent.push(
            createElement('x-search-tree', {
              props,
              attrs,
              on: {
                'remove-tag': ({ tag, index }) => {
                  item.removeTag &&
                    item.removeTag({ item, tag, model, list: this.conditionConfig.list, index });
                },
                'click-icon': $event => {
                  this.handleClickIcon(item, $event);
                },
                select: data => {
                  this.handleSearchTreeSelect(item, data);
                },
                clear: () => {
                  this.handleClear(item);
                },
                input: $event => {
                  model[field] = $event;
                }
              }
            })
          );
        } else if (type === FIELD_TYPE_LIST_POP_ONE || type === FIELD_TYPE_LIST_POP_MULTI) {
          const listeners = {
            'click-icon': $event => {
              this.handleClickIcon(item, $event);
            },
            select: data => {
              this.handleSearchListSelect(item, data);
            },
            clear: () => {
              this.handleClear(item);
            },
            input: $event => {
              model[field] = $event;
            },
            'update:fullData': data => {
              this.handleSearchListUpdateFullData({ item, data });
            }
          };
          if (item.opened) {
            listeners.opened = item.opened;
          }
          const props = {
            value: model[field],
            presetButtonConfig: item.buttonConfig,
            disabled: this.isDisabled(item),
            appendResult: item.appendResult,
            searchOptionType:
              FIELD_TYPE_LIST_POP_ONE === item.type ? SINGLE_SELECT : MULTIPLE_SELECT,
            mode: item.mode,
            quickQueryData: item.quickQueryData,
            validate: item.validate
          };
          if (item.triggerSearch) {
            props.triggerSearch = args => {
              this.handleTriggerSearch(item, args);
            };
          }
          if (item.limit) {
            props.limit = item.limit;
          }
          const attrs = {
            api: item.api,
            rowKey: item.rowKey,
            rowName: item.rowName,
            appendToBody: item.appendToBody,
            // presetConfig: item.presetConfig,
            pageConfig: item.pageConfig,
            conditionConfig: item.conditionConfig,
            columns: item.columns,
            readonlyClearable: item.readonlyClearable,
            placeholder: this.getPlaceholder({item}),
            presetQueryParams: item.presetQueryParams,
            handleResult: item.handleResult,
            handleQueryParams: item.handleQueryParams,
            columnCache: item.columnCache
          };
          if (item.width) {
            attrs.width = item.width;
          }
          if (item.height) {
            attrs.height = item.height;
          }
          if (item.renderKey) {
            attrs.renderKey = item.renderKey;
          }
          formItemContent.push(
            createElement('x-search-list', {
              props,
              attrs,
              on: listeners,
              ref: item.ref
            })
          );
        } else if (type === FIELD_TYPE_FILE) {
          const uploadProps = {
            isMinIo: item.isMinIo,
            showFileName: item.showFileName,
            uploadTipClass: item.uploadTipClass,
            uploadTip: item.uploadTip,
            isGetNameFromRemote: item.isGetNameFromRemote,
            action: item.action,
            limit: item.limit,
            accept: item.accept,
            tip: item.tip,
            onSuccess: item.onSuccess,
            onRemove: item.onRemove,
            size: item.size,
            listType: item.listType,
            convertUploadFiles: ({ file, uploadFiles }) => {
              this.convertUploadFiles({ file, uploadFiles, item });
            }
          };
          const disabled = this.isDisabled(item);
          const uploadAttrs = {
            data: item.data,
            headers: item.headers,
            disabled
          };
          if (hasOwnProperty.call(item, 'showFileName')) {
            uploadProps.showFileName = item.showFileName;
          }
          if (hasOwnProperty.call(item, 'previewMode')) {
            uploadProps.previewMode = item.previewMode;
          }
          if (hasOwnProperty.call(item, 'listType')) {
            uploadProps.listType = item.listType;
          }
          if (item.beforeUpload) {
            uploadProps.beforeUpload = file => {
              return item.beforeUpload({ file, item });
            };
          }
          const uploadChildren = [];
          if (item.topTip) {
            uploadChildren.push(createElement('div', {slot: 'topTip', domProps: {innerHTML: item.topTip}}));
          }
          // 上传组件的显示方案，dialog就是弹窗，inline就是直接显示在表单组件里面，
          // 默认是dialog
          if (item.displayMode === 'inline') {
            // inline的方式，fileList需要使用缓存数据，否则每次改变界面数据，图片都会重新渲染，触发跳动的动画
            let fileList = item.fileList;
            if (!Array.isArray(fileList)) {
              fileList = [];
              item.fileList = fileList;
            }
            if (item.convertFileList) {
              // 对比fileList和$fileList，如果发现某个元素不同，就从不同的位置开始截取后面的元素放入fileList中
              const $fileList = item.convertFileList({item, model});
              if ($fileList.length !== fileList.length) {
                fileList.push(...$fileList);
              } else {
                for (let m = 0; m < $fileList.length; m++) {
                  if (fileList[m].id + '' === $fileList[m].id || fileList[m].url + '' === $fileList[m].url) {
                    continue;
                  }
                  for(let n = m; n < $fileList.length; n++) {
                    fileList[n] = $fileList[n];
                  }
                  break;
                }
              }
            }
            uploadProps.fileList = fileList;
            formItemContent.push(
              createElement('x-upload', {
                props: uploadProps,
                attrs: uploadAttrs,
                ref: item.ref,
                refInFor: true
              }, uploadChildren)
            );
          } else {
            // 弹窗的形式，组件每次都会重新渲染，所以fileList需要重新赋值
            let fileList = [];
            if (item.convertFileList) {
              fileList = item.convertFileList({item, model});
            }
            formItemContent.push(
              createElement('span', {
                class: 'el-form-item-upload',
                on: {
                  click: () => {
                    const Wrapper = Vue.extend({
                      name: 'XUploadDialogWrapperEdit',
                      data() {
                        return {
                          visible: false
                        };
                      },
                      render (createElement) {
                        // return createElement('div', {}, '你好');
                        if (!this.visible) {
                          return null;
                        }

                        return createElement('x-upload-dialog', {
                          attrs: {
                            ...uploadProps,
                            ...uploadAttrs,
                            fileList,
                            visible: true,
                          },
                          on: {
                            'update:visible': (args) => {
                              if (args === false) {
                                wrapper.$destroy();
                              }
                            }
                          }
                        }, uploadChildren);
                      }
                    });
                    const wrapper = new Wrapper({
                      el: document.createElement('div'),
                      parent: this
                    });
                    console.log(this);
                    setTimeout(() => {
                      wrapper.visible = true;
                    }, 100);
                  }
                }
              }, [createElement('span', {}, this.isDisabled(item) ? '查看' : '选择'), createElement('span', {class: 'x-upload-dialog-file-list-length'}, '(' + fileList.length + ')')])
            );
          }
        } else if (type === FIELD_TYPE_RICH_TEXT) {
          formItemContent.push(
            createElement(XTinymce, {
              props: {
                value: model[field],
                buttonConfig: item.buttonConfig,
                disabled: this.isDisabled(item)
              },
              on: {
                input: $event => {
                  model[field] = $event;
                }
              }
            })
          );
        } else {
          console.error('未设置condition-item的类型', item);
          throw new Error('未设置condition-item的类型');
        }
        const scopedSlots = {};
        if (item.errorSlot && this.$scopedSlots[item.errorSlot.name]) {
          scopedSlots.error = props => this.$scopedSlots[item.errorSlot.name](props);
        }
        if (item.labelRender) {
          formItemContent.push(createElement('template', {slot: 'label'}, item.labelRender({createElement, item, conditionConfig: this.conditionConfig, model})));
        }
        colList.push(
          createElement(
            'el-col',
            {
              key: item.field,
              props: {
                span: getSpan({model, conditionConfig: this.conditionConfig, item})
              },
              style
            },
            [
              createElement(
                'x-form-item',
                {
                  // 不再el-form-item中使用required属性，因为一旦使用该属性且为true,就会生成一个{required: true}的rule,不方便通过realRules来控制
                  class: item.formItemClass,
                  attrs: {
                    labelWidth: item.labelWidth,
                    label: item.labelMethod ? item.labelMethod({model, conditionConfig: this.conditionConfig, item}) : item.label
                  },
                  props: {
                    prop: item.field,
                    iconRight: this.getIconRight(item)
                  },
                  key: item.field,
                  scopedSlots
                },
                formItemContent
              )
            ]
          )
        );
      }
      const style = {};
      if (displayFlag) {
        style.display = 'none';
      }
      children.push(
        createElement(
          'el-row',
          {
            key: i,
            style
          },
          colList
        )
      );
    }
    if (this.realDrawerConfig.show && this.realShowList.length > this.realDrawerConfig.limit) {
      children.push(
        createElement('el-row', {}, [
          createElement(
            'el-col',
            {
              class: 'x-condition-drawer-wrapper',
              props: {
                span: 24
              }
            },
            [
              createElement(
                'span',
                {
                  class: 'x-condition-drawer',
                  on: {
                    click: () => {
                      this.realDrawerFlag = !this.realDrawerFlag;
                    }
                  }
                },
                [
                  createElement('span', {
                    class: {
                      'x-condition-drawer-icon': true,
                      'el-icon-caret-top': this.realDrawerFlag,
                      'el-icon-caret-bottom': !this.realDrawerFlag
                    }
                  }),
                  createElement(
                    'span',
                    {
                      class: 'x-condition-drawer-text'
                    },
                    this.realDrawerFlag
                      ? this.realDrawerConfig.closeText
                      : this.realDrawerConfig.openText
                  )
                ]
              )
            ]
          )
        ])
      );
    }
    return createElement(
      'el-form',
      {
        ref: 'form',
        props: {
          labelWidth: this.realLabelWidth,
          model: this.conditionConfig.model,
          rules: this.realRules,
          validateOnRuleChange: false,
          labelPosition: this.conditionConfig.labelPosition || 'right'
        },
        class: 'x-condition',
        nativeOn: {
          submit: event => {
            event.preventDefault();
          }
        }
      },
      children
    );
  },
  methods: {
    getInputAttribute (item, adjustFlag) {
      const model = this.conditionConfig.model;
      const field = item.field;
      const type = item.type;
      const clazzObj = { 'x-condition-adjust-input': adjustFlag };
      if (item.type === FIELD_TYPE_NATIVE_INPUT_NUMBER) {
        clazzObj['native-input-number'] = true;
      }
      return {
        props: {
          ...item,
          readonly: item.readonly || false,
          disabled: this.isDisabled(item),
          clearable: item.clearable || false,
          value: model[field],
          type: type === FIELD_TYPE_INPUT ? 'text' : type
        },
        attrs: {
          min: item.min,
          max: item.max,
          minlength: item.minlength,
          maxlength: item.maxlength,
          rows: item.rows,
          placeholder: this.getPlaceholder({item, defaultPlaceholder: '请输入'})
        },
        class: clazzObj,
        on: {
          focus: $event => {
            this.handleFocusChange(item, $event);
          },
          blur: $event => {
            this.handleCommonBlur(item, $event);
          },
          clear: $event => {
            this.handleInputClear(item, $event);
          },
          input: value => {
            model[field] = value;
            this.handleCommonChange(item, value);
          }
        },
        nativeOn: {
          click: () => {
            this.handleCommonClick(item);
          },
          keyup: $event => {
            if (!isEnter($event)) {
              return;
            }
            this.handleKeyupEnterNative(item, $event);
          }
        }
      }
    },
    async handleTriggerSearch(item, args) {
      args.item = item;
      await item.triggerSearch(args);
    },
    createOptions({ item, options, createElement }) {
      const props = item.props;
      const label = props.label;
      const value = props.value;
      const key = props.key;
      const optionElements = [];
      if (Array.isArray(options)) {
        for (const option of options) {
          if (Array.isArray(option.options)) {
            optionElements.push(
              createElement(
                OptionGroup,
                {
                  props: {
                    label: option[label],
                    disabled: this.isOptionDisabled(item, option)
                  },
                  key: option[label]
                },
                this.createOptions({ item, options: option.options, createElement })
              )
            );
            continue;
          }
          optionElements.push(
            createElement(Option, {
              props: {
                label: option[label],
                value: option[value],
                disabled: this.isOptionDisabled(item, option)
              },
              key: option[key]
            })
          );
        }
      }
      return optionElements;
    },
    getVisibleInputButtonList(item) {
      if (
        !item.buttonConfig ||
        !Array.isArray(item.buttonConfig.list) ||
        item.buttonConfig.list.length < 1
      ) {
        return [];
      }
      return getShowList({list: item.buttonConfig.list, config: item.buttonConfig, parentConfig: this.conditionConfig});
    },
    handleInputButtonClick($event, item, buttonItem) {
      if (!buttonItem.click) {
        return;
      }
      buttonItem.click({
        event: $event,
        item,
        buttonItem,
        list: this.conditionConfig.list,
        model: this.conditionConfig.model
      });
    },
    /**
     * 部分没有readonly属性的组件，如果传人readonly也当作disabled处理
     * @param item
     * @return {boolean|*}
     */
    isReadonlyDisabled(item) {
      if (
        Object.prototype.hasOwnProperty.call(item, 'readonly') &&
        appUtils.isBoolean(item.readonly)
      ) {
        return item.readonly;
      }
      return this.isDisabled(item);
    },
    isOptionDisabled(item, option) {
      if (
        Object.prototype.hasOwnProperty.call(option, 'disabled') &&
        appUtils.isBoolean(option.disabled)
      ) {
        return option.disabled;
      }
      if (option.disabledMethod) {
        const disabled = option.disabledMethod({
          conditionConfig: this.conditionConfig,
          model: this.conditionConfig.model,
          item,
          option
        });
        if (disabled === true) {
          return disabled;
        }
      }
      return false;
    },
    isButtonDisabled(button, item) {
      if (Object.prototype.hasOwnProperty.call(button, 'disabled')) {
        if (button.disabled === true) {
          return true;
        }
      }
      return this.isDisabled(item);
    },
    isDisabled(item) {
      // 如果conditionConfig有disabledMethod且返回值是true,则整个表单都是禁用状态
      if (this.conditionConfig.disabledMethod) {
        const baseDisabled =  this.conditionConfig.disabledMethod({
          conditionConfig: this.conditionConfig,
          model: this.conditionConfig.model
        });
        if (baseDisabled === true) {
          return baseDisabled;
        }
      }
      const hasOwnProperty = Object.prototype.hasOwnProperty;
      // 如果conditionConfig的disabled属性是true，则整个表单都是禁用状态
      if (hasOwnProperty.call(this.conditionConfig, 'disabled')) {
        if (this.conditionConfig.disabled === true || this.conditionConfig.disabled === 'true') {
          return true;
        }
      }
      if (item.disabledMethod) {
        return item.disabledMethod({
          conditionConfig: this.conditionConfig,
          model: this.conditionConfig.model,
          item
        });
      }
      if (hasOwnProperty.call(item, 'disabled')) {
        return item.disabled;
      }
      return false;
    },
    isReadonly(item) {
      return item.readonly || false;
    },
    isEditable(item) {
      return item.editable || true;
    },
    /**
     * 获取placeholder
     * @param item
     * @param key item的属性，默认是'placeholder'
     * @param defaultPlaceholder
     * @return {*|string}
     */
    getPlaceholder({item, key = 'placeholder', defaultPlaceholder}) {
      // 如果是不能编辑的，就不显示placeholder
      if (this.isDisabled(item)) {
        return '';
      }
      if (item[key] === undefined || item[key] === null) {
        return defaultPlaceholder;
      }
      return item[key];
    },
    handleKeyupEnterNative(item, event) {
      if (!item.enter) {
        return;
      }
      item.enter({
        item,
        event,
        conditionConfig: this.conditionConfig,
        model: this.conditionConfig.model
      });
    },
    handleInputClear(item, event) {
      if (!item.clear) {
        return;
      }
      item.clear({ item, event });
    },
    handleCommonChange(item, value, oldValue) {
      // cascader要将node赋值到item中
      if (item.type === FIELD_TYPE_CASCADER) {
        if (!item.params) {
          item.params = {};
        }
        const checkedNodes = this.$refs[item.ref][0].getCheckedNodes();
        if (!Array.isArray(checkedNodes) || checkedNodes.length < 1) {
          item.params.pathData = [];
        } else {
          const pathNodes = checkedNodes[0].pathNodes;
          const arr = [];
          for (const node of pathNodes) {
            arr.push(node.data);
          }
          item.params.pathData = arr;
        }
      }
      if (!item.change) {
        return;
      }
      item.change({
        item,
        value,
        list: this.conditionConfig.list,
        model: this.conditionConfig.model,
        conditionConfig: this.conditionConfig,
        oldValue,
        vm: this
      });
    },
    handleCommonBlur(item, event) {
      if (!item.blur) {
        return;
      }
      item.blur({ item, event });
    },
    handleFocusChange(item, event) {
      if (!item.focus) {
        return;
      }
      item.focus({ item, event });
    },
    handleCommonClick(item) {
      if (!item.click) {
        return;
      }
      item.click({ item });
    },
    getFormInstance() {
      return this.$refs.form;
    },
    handleClickIcon(item, args) {
      if (!item.clickIcon) {
        return;
      }
      args.item = item;
      item.clickIcon(args);
    },
    /**
     * @desc 表单校验，由于el-form返回的promise只是带有true/false, 因此这里增加返回的信息
     * @param callback
     * @return {promise}
     */
    validate(callback) {
      // 判断图片是否上传完成
      const conditionConfig = this.conditionConfig;
      for (const item of conditionConfig.list) {
        if (item.type !== FIELD_TYPE_FILE) {
          continue;
        }
        if (!Array.isArray(this.$refs[item.ref]) || this.$refs[item.ref].length < 1) {
          continue;
        }
        const uploadFiles = this.$refs[item.ref][0].uploadFiles;
        if (!Array.isArray(uploadFiles)) {
          continue;
        }
        for (const file of uploadFiles) {
          if (file.status === 'uploading') {
            return Promise.reject(new RuleError('文件上传中'));
          }
        }
      }
      let resolveFn = null;
      let rejectFn = null;
      const promise = new Promise((resolve, reject) => {
        resolveFn = resolve;
        rejectFn = reject;
      });
      const $callback = (valid, invalidFields) => {
        callback && callback(valid, invalidFields);
        if (valid) {
          resolveFn();
        } else {
          const ruleError = new RuleError('请正确填写表单');
          // 加入label属性
          for (const key in invalidFields) {
            const invalidFieldArray = invalidFields[key];
            for (const item of this.conditionConfig.list) {
              if (item.field !== key) {
                continue;
              }
              for (const invalidField of invalidFieldArray) {
                invalidField.label = item.label;
              }
            }
          }
          ruleError.invalidFields = invalidFields;
          this.realDrawerFlag = true;
          rejectFn(ruleError);
        }
      };
      // 空格在el-form的非空校验中通过，因此这里需要将前后空格去掉
      const model = conditionConfig.model;
      for (const key in model) {
        const value = model[key];
        if (appUtils.isString(value)) {
          model[key] = value.trim();
        }
      }
      this.$refs.form.validate($callback);
      return promise;
    },
    handleSearchListSelect(item, data) {
      if (!item.searchListSelect) {
        return;
      }
      item.searchListSelect({
        item,
        data,
        value: data,
        list: this.conditionConfig.list,
        model: this.conditionConfig.model
      });
    },
    handleSearchListUpdateFullData({ item, data }) {
      item.fullData = data;
      if (!item.updateFullData) {
        return;
      }
      item.updateFullData({
        item,
        data,
        value: data,
        list: this.conditionConfig.list,
        model: this.conditionConfig.model
      });
    },
    handleSearchTreeSelect(item, data) {
      if (!item.searchTreeSelect) {
        return;
      }
      item.searchTreeSelect({
        item,
        data,
        value: data,
        list: this.conditionConfig.list,
        model: this.conditionConfig.model
      });
    },
    getIconRight(item) {
      if (Object.prototype.hasOwnProperty.call(item, 'iconRight')) {
        return item.iconRight;
      }
      const type = item.type;
      if (
        type === FIELD_TYPE_POP_ONE ||
        type === FIELD_TYPE_POP_MULTI ||
        type === FIELD_TYPE_TREE_POP_ONE ||
        type === FIELD_TYPE_TREE_POP_MULTI ||
        type === FIELD_TYPE_LIST_POP_ONE ||
        type === FIELD_TYPE_LIST_POP_MULTI
      ) {
        return 25;
      } else if (type === FIELD_TYPE_NATIVE_INPUT_NUMBER) {
        return 20;
      }
    },
    convertUploadFiles({ file, uploadFiles, item }) {
      // 将uploadFiles保存起来，用于预览
      item.uploadFiles = uploadFiles;
      const model = this.conditionConfig.model;
      if (item.convertUploadFiles) {
        const list = item.convertUploadFiles({
          file,
          uploadFiles,
          item,
          model,
          list: this.conditionConfig.list
        });
        if (Array.isArray(list)) {
          model[item.field] = list;
        }
        return;
      }
      // 默认转换成一个id数组
      const arr = [];
      for (const uploadFile of uploadFiles) {
        // 同时上传多张图片，uploadFile.response可能为空，因为有些图片未上传完成
        if (uploadFile.response) {
          // 当前上传的图片
          arr.push(uploadFile.response.data.id);
        } else {
          // 通过fileList传入的图片
          arr.push(uploadFile.id);
        }
      }
      model[item.field] = arr;
    },
    handleClear(item) {
      if (item.clear) {
        item.clear({ item, list: this.conditionConfig.list, model: this.conditionConfig.model });
      }
    }
  },
  created() {
    this.realDrawerFlag = this.drawerFlag;
    initModel(this.conditionConfig);
  },
  mounted() {
    if (this.erd) {
      this.erd.uninstall(this.$el);
      this.erd = null;
    }
    this.erd = elementResizeDetector();
    this.erd.listenTo(
      this.$el,
      debounce(element => {
        this.$emit('resize', { element, context: this });
      }, 250)
    );
  },
  computed: {
    realDrawerConfig() {
      const defaultConfig = { show: false, openText: '展开', closeText: '收起', limit: 4 };
      if (!this.drawerConfig) {
        return defaultConfig;
      }
      return Object.assign(defaultConfig, this.drawerConfig);
    },
    realShowList() {
      return getShowList({list: this.conditionConfig.list, config: this.conditionConfig});
    },
    realRules() {
      if (!this.conditionConfig.rules) {
        return {};
      }
      for (const key in this.conditionConfig.rules) {
        const arr = this.conditionConfig.rules[key];
        for (const item of arr) {
          if (item.validator && !item.validator.$packaged) {
            const realValidator = item.validator;
            item.validator = (rule, value, callback, source, options) => {
              // element-ui中source只有当前检验项的值，需要改为整个表单的数据
              source = this.conditionConfig.model;
              return realValidator(rule, value, callback, source, options);
            };
            item.validator.$packaged = true;
          }
        }
      }
      return this.conditionConfig.rules;
    },
    realLabelWidth() {
      return this.conditionConfig.labelWidth || '80px';
    }
  },
  beforeDestroy() {
    if (this.erd) {
      this.erd.uninstall(this.$el);
      this.erd = null;
    }
  },
  watch: {
    'conditionConfig.list': {
      handler(newList) {
        if (!Array.isArray(newList)) {
          return;
        }
        for (let i = 0; i < newList.length; i++) {
          const item = newList[i];
          const type = item.type;
          const hasOwnProperty = Object.prototype.hasOwnProperty;
          if (!hasOwnProperty.call(item, 'clearable')) {
            // 默认可以清空
            item.clearable = true;
          }
          if (type === FIELD_TYPE_TITLE) {
            item.span = 24;
            item.labelWidth = '100%';
            item.formItemClass = addClass({collection: item.formItemClass, item: 'x-form-item-group-title'});
            if (item.hideBorder) {
              item.formItemClass = addClass({collection: item.formItemClass, item: 'x-form-item-group-title-no-border'});
            }
            continue;
          }
          if (!hasOwnProperty.call(item, 'span')) {
            item.span = 6;
          }
          if (type === FIELD_TYPE_SELECT || type === FIELD_TYPE_MULTIPLE_SELECT) {
            // 对于type === 'select'的选项，如果没有设置props, 需要设置默认值
            if (!item.props) {
              item.props = { value: 'value', label: 'label', key: 'value' };
            } else {
              const props = item.props;
              if (!props.value) {
                props.value = 'value';
              }
              if (!props.label) {
                props.label = 'label';
              }
              if (!props.key) {
                props.key = props.value;
              }
            }
          }
          if (
            (type === FIELD_TYPE_INPUT || type === FIELD_TYPE_TEXTAREA) &&
            item.buttonConfig &&
            Array.isArray(item.buttonConfig.list)
          ) {
            for (const buttonItem of item.buttonConfig.list) {
              if (!buttonItem.field) {
                buttonItem.field = buttonItem.name;
              }
            }
          }
          if ((item.type === FIELD_TYPE_CASCADER || item.type === FIELD_TYPE_FILE) && !item.ref) {
            item.ref = 'ref-' + item.field + '-' + Date.now() + '-' + i;
          }
          // 如果是日期类型，没有pickerOptions属性就加上，如果有这个属性或者是null，就不处理
          if (type === FIELD_TYPE_DATE || type === FIELD_TYPE_DATETIME) {
            if (!hasOwnProperty.call(item, 'pickerOptions')) {
              item.pickerOptions = {
                shortcuts: [
                  {
                    text: '今天',
                    onClick(picker) {
                      picker.$emit('pick', new Date());
                    }
                  },
                  {
                    text: '昨天',
                    onClick(picker) {
                      const date = new Date();
                      date.setDate(date.getDate() - 1);
                      picker.$emit('pick', date);
                    }
                  }
                ]
              };
            }
          }
          if (type === FIELD_TYPE_DATERANGE || type === FIELD_TYPE_DATETIME_RANGE) {
            if (!hasOwnProperty.call(item, 'pickerOptions')) {
              item.pickerOptions = {
                shortcuts: [
                  {
                    text: '最近一周',
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                      picker.$emit('pick', [start, end]);
                    }
                  },
                  {
                    text: '最近一个月',
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                      picker.$emit('pick', [start, end]);
                    }
                  }
                ]
              };
            }
          }
        }
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss">
@import "../../style/mixins/_vars.scss";
.x-condition {
  .el-col{
    .x-condition-adjust-item {
      width: 100%;
    }
  }
  .el-input__inner[type=number] {
    padding-right: 0;
  }
  .native-input-number {
    .el-input__suffix {
      padding-right: 10px;
    }
  }
}
.x-condition-cascader .el-scrollbar {
  max-height: 70vh;
}
.x-condition-drawer-wrapper {
  font-size: 0;
  text-align: center;
  padding-bottom: 1px;
}
.x-condition-drawer {
  display: inline-block;
  color: $primary-color;
  &:hover {
    cursor: pointer;
  }
}
.x-condition-drawer-icon, .x-condition-drawer-text {
  line-height: 12px;
}
.x-condition-drawer-icon {
  font-size: 12px;
}
.x-condition-drawer-text {
  display: inline-block;
  font-size: 12px;
  padding-left: 5px;
  font-weight: bold;
}

.x-condition-adjust-input-form-item {
  display: flex;
  flex-direction: row;
}

.x-condition-adjust-input {
  flex: 1 1 auto;
  margin-right: 4px;
}

.x-condition-input-button-wrapper {
  flex: 0 0 auto;
}
.x-form-item-group-title {
  font-weight: bold;
  .el-form-item__label {
    padding: 0;
    text-align: left;
    border-bottom: 1px solid #ccc;
  }
}
.x-form-item-group-title-no-border {
  .el-form-item__label {
    border-bottom: none;
  }
}
</style>